/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Team_OrgInputs */

const cs_pipelines_team_org = /** @type {(inputs: Pipelines_Team_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celá organizace`)
};

const en_pipelines_team_org = /** @type {(inputs: Pipelines_Team_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization-wide`)
};

/**
* | output |
* | --- |
* | "Organization-wide" |
*
* @param {Pipelines_Team_OrgInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_team_org = /** @type {((inputs?: Pipelines_Team_OrgInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Team_OrgInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_team_org(inputs)
	return cs_pipelines_team_org(inputs)
});